import React from 'react';

import styled from 'styled-components';

import { ContractBenefitsTableRow } from './types';

const CategoryGroup = styled.div`
  margin-bottom: 8px;
`;

const CategoryTitle = styled.div`
  font-family: var(--font-bold);
`;

type Props = {
  index: number;
  record?: ContractBenefitsTableRow;
};

const ContractBenefitsTableItem = ({ record, index }: Props) => {
  if (!record?.rowItems?.length) {
    return null;
  }

  const rowItem = record.rowItems[index];
  if (!rowItem || !rowItem.groupedBenefits) {
    return null;
  }

  return (
    <div>
      {Object.entries(rowItem.groupedBenefits).map(([categoryName, benefits]) => (
        <div key={categoryName}>
          <CategoryGroup>
            <CategoryTitle>{categoryName}</CategoryTitle>
            {benefits.map((benefit, i) => (
              <div key={i}>· {benefit}</div>
            ))}
          </CategoryGroup>
        </div>
      ))}
    </div>
  );
};

export default ContractBenefitsTableItem;
